import '@/util/permission';
import Vue from 'vue';
import * as echarts from 'echarts/core';
import * as utils from '@/util/format';
import VueMoment from 'vue-moment';
import { ValidationProvider } from 'vee-validate';
import '@/util/vee-validate';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'tabulator-tables/dist/css/tabulator_midnight.min.css';
import vuetify from '@/plugins/vuetify';
import i18n from '@/locale';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import Router from 'vue-router';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VChart from 'vue-echarts';
import VueTabulator from 'vue-tabulator';
import { TrackerPlugin } from 'web-event-tracker/vue2';

import {
	round_off as g_round_off,
	round_percent as g_round_percent,
	number_2_text as g_number_2_text,
} from '@/util/format';

import {
	LocalStorage,
	SessionStorage,
} from '@/storage';
import * as g_aq from 'arquero';
import * as echarts_helper from '@/assets/chart_handler/echarts_helper';
import * as TabuHandler from '@/assets/chart_handler/TabuHandler';
import pinia from '@/stores';
import { event_bus } from '@/event_bus';

global.g_round_off = g_round_off;
global.g_round_percent = g_round_percent;
global.g_number_2_text = g_number_2_text;

global.g_aq = g_aq;
global.echarts_helper = echarts_helper;
global.TabuHandler = TabuHandler;

global.LocalStorage = LocalStorage.constructor();
global.SessionStorage = SessionStorage.constructor();

import 'swiper/dist/css/swiper.css';
import { CanvasRenderer, SVGRenderer } from 'echarts/renderers';
import { BarChart, FunnelChart, HeatmapChart, LineChart, PieChart, SankeyChart, RadarChart } from 'echarts/charts';
import {
	BrushComponent,
	DatasetComponent,
	DataZoomComponent,
	DataZoomInsideComponent,
	DataZoomSliderComponent,
	GridComponent,
	GridSimpleComponent,
	GraphicComponent,
	MarkLineComponent,
	MarkPointComponent,
	TitleComponent,
	ToolboxComponent,
	TooltipComponent,
	TransformComponent,
	LegendComponent,
	LegendScrollComponent,
	LegendPlainComponent,
	VisualMapComponent
} from 'echarts/components';
echarts.use([
	CanvasRenderer, SVGRenderer,
	BarChart, FunnelChart, HeatmapChart, LineChart, PieChart, SankeyChart, RadarChart,
	BrushComponent,
	DatasetComponent,
	DataZoomComponent,
	DataZoomInsideComponent,
	DataZoomSliderComponent,
	GridComponent,
	GridSimpleComponent,
	GraphicComponent,
	MarkLineComponent,
	MarkPointComponent,
	TitleComponent,
	ToolboxComponent,
	TooltipComponent,
	TransformComponent,
	LegendComponent,
	LegendScrollComponent,
	LegendPlainComponent,
	VisualMapComponent
]);

Vue.config.productionTip = false;
Vue.use(VueMoment);
Vue.use(VueAwesomeSwiper);
Vue.use(VueTabulator);

// 初始化 Web Event Tracker
// 透過 cars-ap 作為 proxy 連接到 odp-api
Vue.use(TrackerPlugin, {
	endpoint: '/cars/web-event-tracker',  // 使用相對路徑，自動透過 cars-ap proxy
	app_id: 'CARS',
	site_id: 'SPGAME', //TODO: 改成 CARS
	debug: process.env.NODE_ENV !== 'production',
	batch_size: 5,
	batch_interval: 3000,
	watch_dom: true,
	fetch_rules_on_init: true,
	fetch_config_on_init: true,
	track_spa_navigation: true
});

Vue.component('v-chart', VChart);
Vue.component('ValidationProvider', ValidationProvider);
// Vue.component(ValidationProvider);

Vue.filter('commaFormatter', value => utils.commaFormatter(value));

Vue.prototype.$event_bus = event_bus;

const app = new Vue({
	vuetify,
	router,
	store,
	pinia,
	i18n,
	render: h => h(App),
	mounted() {
		// 頁面載入時，從 sessionStorage 恢復 user_id
		const operator_str = window.sessionStorage.getItem('operator');
		if (operator_str && this.$tracker) {
			try {
				const operator = JSON.parse(operator_str);
				if (operator.operatorName) {
					this.$tracker.set_user_id(operator.operatorName);
				}
			} catch (e) {
				console.error('[Web Event Tracker] 解析 operator 失敗:', e);
			}
		}

		// 監聽登入狀態變化，更新 tracker 的 user_id
		this.$store.watch(
			(state) => state.user.operator,
			(operator) => {
				if (operator && operator.operatorName && this.$tracker) {
					// 更新 tracker 的 user_id
					this.$tracker.set_user_id(operator.operatorName);
				}
			}
		);
	}
}).$mount('#app');

// 避免Router重複點擊錯誤
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return routerPush.call(this, location).catch(error => error);
};
